import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// utils
import { Translations } from '../../../utils';
// restClient
import { eapiClient, aemHostClient, taxonomyHostClient } from '../../../restClient';
// children
import SimpleDropdown from '../../common/SimpleDropdown';
import ConstomerInCase from './Child/ConstomerInCase';
import NewAccounts from './Child/NewAccounts';
import EChannels from './Child/EChannels';
import PreviewIE from '../../CaseList/PreviewGLS/IEPreview/PreviewIE';
import PreviewNP from '../../CaseList/PreviewGLS/NPPreview/PreviewNP';
import PreviewCashCon from '../../CaseList/PreviewGLS/CCPreview/PreviewCashCon';
import AdditionalData from './Child/AdditionalData';
import AchCredit from './Child/AchCredit/AchCredit';
import CorporateCard from './Child/CorporateCard/CorporateCard';
//action Creator
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
//style
import './index.css';
//import GlsProducts from './Child/GlsProducts';
import CashFlowForecasting from './Child/Cash Flow Forecasting';

class PreviewRequest extends Component {

  constructor(props) {
    super(props);
    this.state = {
      entityFilterSelection: '',
      originalData: {
        entityDetails: [],
        productDetails: {
          accounts: [],
          eChannels: [],
          gls: [],
          ach: [],
          countryForms: [],
          productReferenceObjects: []
        }
      },
      filterData: {
        entityDetails: [],
        productDetails: {
          accounts: [],
          eChannels: [],
          gls: [],
          ach: [],
          productReferenceObjects: [],
          countryForms: [],
          cff: []
        }
      }
    };
  }

  getAccountCountryTaxanomy = () => {
    taxonomyHostClient(Translations(this.state.pageJson.dynamic_accordion_list_accounts.accountTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          this.setState({ accountCountryList: data.responseData.countryTaxonomy.classificationNodes })
        }
      });

    taxonomyHostClient(Translations(this.state.pageJson.dynamic_accordion_list_eChannels.countryTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
      .then(({ data }) => {
        this.setState({ countryList: data.responseData.classificationNodes })
      })

    taxonomyHostClient(Translations(this.state.pageJson.dynamic_accordion_list_achCredits.achTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
      .then(({ data }) => {
        this.setState({ achCountryList: data.responseData.classificationNodes })
      })
  }

  componentWillMount() {
    const currentCase = this.props.cases[(Object.keys(this.props.cases))[0]];
    // const currentCase = {
    //   //caseId :"urn:uuid:4d1122388615475b8e84fe0796ecfe45"
    // }
    if (currentCase !== undefined && currentCase.caseId !== undefined) {

      aemHostClient("/aemData/formData/json_preview-request-open")
        .then(({ data, status }) => {
          this.setState({ pageJson: data.par })
          this.getAccountCountryTaxanomy();
        });

      eapiClient(`/cases/${currentCase.caseId}/previewRequest`, { timeout: 420000 })
        .then(({ data, status }) => {
          if (data.responseData !== '' || data.responseData !== undefined) {
            data.responseData.productDetails.gls.forEach((item, index) => {
              if (item.cashConcentration !== undefined) {
                let order = item.cashConcentration.orderOfExecution;
                let _unique = [];
                let sweepLists = [];
                let finalList = [];
                order.map(x => _unique.filter(a => a.sweepId === x.sweepId).length > 0 ? null : _unique.push(x));
                order.map(x => _unique.filter(a => a.sweepGroupId === x.sweepGroupId).length > 0 ? null : _unique.push(x));
                _unique.forEach(element => {
                  if (element.intraGroupOrder) {
                    element.intraGroupOrder.forEach(ele => {
                      sweepLists.push({ sweepId: ele.sweepInstructionId })
                    });
                  }
                });
                //  _unique.forEach((x)=>{ delete x.orderNumber });
                _unique.map(x => sweepLists.filter(a => a.sweepId === x.sweepId).length > 0 ? null : finalList.push(x));
                let orderList = finalList.map((item, i) => {
                  return {
                    //  orderNumber: i+1,
                    ...item
                  }
                })
                item.cashConcentration.orderOfExecution = orderList;
              }
            })
            data.responseData.productDetails.corporateCards.forEach((item, index) => {
              let currencyType = [];
              let cardType = [];
              let res = item.specificDetails !== undefined && item.specificDetails.cardAndCurrencies !== undefined ? item.specificDetails.cardAndCurrencies : [];
              if (res !== undefined) {
                for (let i of res) {
                  for (let curr of i.currencyLst) {
                    currencyType.push(curr);
                  }
                }
                for (let i of res) {
                  cardType.push(i.cardType);
                } for (let i of res) {
                  for (let curr of i.currencyLst) {
                    currencyType.push(curr);
                  }
                }
                for (let i of res) {
                  cardType.push(i.cardType);
                }
              }
              if (item.specificDetails !== undefined) {
                item.specificDetails.currencyType = currencyType;
                item.specificDetails.cardType = cardType;
              }
              if (item.specificDetails !== undefined && item.specificDetails.b2bSolution !== undefined && item.specificDetails.b2bSolution === true) {
                if (item.specificDetails.supplierNameLst !== undefined && item.specificDetails.supplierNameLst.length > 0) {

                  let supplierNameLst1, supplierNameLst2, supplierNameLst3, supplierNameLst4, supplierNameLst5;
                  let suppliers = item.specificDetails.supplierNameLst;
                  if (suppliers.length === 1) {
                    supplierNameLst1 = suppliers[0];
                  } if (suppliers.length === 2) {
                    supplierNameLst1 = suppliers[0];
                    supplierNameLst2 = suppliers[1];
                  } if (suppliers.length === 3) {
                    supplierNameLst1 = suppliers[0];
                    supplierNameLst2 = suppliers[1];
                    supplierNameLst3 = suppliers[2];
                  } if (suppliers.length === 4) {
                    supplierNameLst1 = suppliers[0];
                    supplierNameLst2 = suppliers[1];
                    supplierNameLst3 = suppliers[2];
                    supplierNameLst4 = suppliers[3];
                  } if (suppliers.length === 5) {
                    supplierNameLst1 = suppliers[0];
                    supplierNameLst2 = suppliers[1];
                    supplierNameLst3 = suppliers[2];
                    supplierNameLst4 = suppliers[3];
                    supplierNameLst5 = suppliers[4];
                  }
                  item.specificDetails.supplierNameLst1 = supplierNameLst1;
                  item.specificDetails.supplierNameLst2 = supplierNameLst2;
                  item.specificDetails.supplierNameLst3 = supplierNameLst3;
                  item.specificDetails.supplierNameLst4 = supplierNameLst4;
                  item.specificDetails.supplierNameLst5 = supplierNameLst5;
                }
              }
            });
            this.setState({
              originalData: data.responseData,
              filterData: data.responseData
            });
          }
        })

      try {
        let heading;
        const currentCase = this.props.cases[(Object.keys(this.props.cases))[0]];
        if (Object.keys(this.props.cases).length > 1) {
          const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
          heading = `${currentCase.entityName} (+${noOfCasesExcludingRoot} others)`;
        } else {
          heading = currentCase.entityName;
        }
        aemHostClient("/aemData/formData/json_dark-title-bar")
          .then(({ data, status }) => {
            this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
          });
      } catch (e) {
      }
    } else {
      this.props.history.push('/case-list/');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getAccountCountryTaxanomy();
    }
  }

  filterByEntity = (event) => {
    this.setState({ entityFilterSelection: event.target.value });
    // var _caseId;
    // var situation;
    // if(event.target.value === "all") {
    //   _caseId = Object.keys(this.props.cases)[0];
    //   situation = "/multiEntity";
    // }else {
    //   _caseId = event.target.value;
    //   situation = "/singleEntity";
    // }

    if (event.target.value !== "all") {
      var entityDetails = this.state.originalData.entityDetails.filter((item) => {
        return this.props.cases[event.target.value].entityId === item.id;
      });
      var accounts = this.state.originalData.productDetails.accounts.filter((item) => {
        return item.caseId === event.target.value;
      });
      var eChannels = this.state.originalData.productDetails.eChannels.filter((item) => {
        return item.caseId === event.target.value;
      });
      var gls = this.state.originalData.productDetails.gls.filter((item) => {
        return item.caseId === event.target.value;
      });
      var ach = this.state.originalData.productDetails.ach.filter((item) => {
        return item.caseId === event.target.value;
      });
      var countryForms = this.state.originalData.productDetails.countryForms.filter((item) => {
        return item.caseId === event.target.value;
      });
      var corporateCards = this.state.originalData.productDetails.corporateCards.filter((item) => {
        return item.caseId === event.target.value;
      });
      const cff = this.state.originalData.productDetails.cff.filter((product) => {
        return product.caseId === event.target.value;
      });

      this.setState({
        filterData: {
          entityDetails: entityDetails,
          productDetails: {
            accounts: accounts,
            eChannels: eChannels,
            gls: gls,
            ach: ach,
            countryForms: countryForms,
            corporateCards: corporateCards,
            cff
          }
        }
      });
    } else {
      this.setState({
        filterData: {
          entityDetails: this.state.originalData.entityDetails,
          productDetails: {
            accounts: this.state.originalData.productDetails.accounts,
            eChannels: this.state.originalData.productDetails.eChannels,
            gls: this.state.originalData.productDetails.gls,
            ach: this.state.originalData.productDetails.ach,
            corporateCards: this.state.originalData.productDetails.corporateCards,
            cff: this.state.originalData.productDetails.cff,
            countryForms: this.state.originalData.productDetails.countryForms,
            productReferenceObjects: this.state.originalData.productDetails.productReferenceObjects
          }
        }
      });
    }
  }

  eventToGoCase = () => {
    this.props.history.push('/case-body/');
  }

  render() {
    if (this.state.pageJson !== undefined) {
      return (
        <div>
          <div className="gdoc-preview-request-container">
            <div className="gdoc-preview-request-preview-request">
              <h1>
                {Translations(this.state.pageJson.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
              </h1>
              <div className="gdoc-preview-dropdown">
                {
                  Object.keys(this.props.cases).length > 1 ? (
                    <SimpleDropdown
                      options={this.props.entitiesList}
                      showPleaseSelectOption={false}
                      value={this.state.entityFilterSelection}
                      _onChange={this.filterByEntity}
                      optionTextSelector="entityName"
                      valueSelector="caseId"
                    />
                  ) : ''
                }
              </div>
            </div>
            {
              this.state.filterData !== undefined && this.state.filterData.entityDetails !== undefined && this.state.filterData.entityDetails.length > 0
                ? <div className="gdoc-preview-request-customer-in-case">
                  <ConstomerInCase
                    customerInCase={this.state.filterData.entityDetails}
                    pageJson={this.state.pageJson}
                    lang={this.props.lang}
                    customer={this.props.customer}
                    countryList={this.state.countryList}
                  />
                </div>
                : ""
            }
            {
              this.state.filterData !== undefined && this.state.filterData.productDetails !== undefined && this.state.filterData.productDetails.accounts !== undefined && this.state.filterData.productDetails.accounts.length > 0
                ? <div className="gdoc-preview-request-new-accounts">
                  <NewAccounts
                    newAccounts={this.state.filterData.productDetails.accounts}
                    echannels={this.state.originalData.productDetails.eChannels}
                    pageJson={this.state.pageJson}
                    lang={this.props.lang}
                    countryList={this.state.accountCountryList}
                    countryListForEchannel={this.state.countryList}
                  />
                </div>
                : ""
            }
            {
              this.state.filterData !== undefined && this.state.filterData.productDetails !== undefined && this.state.filterData.productDetails.gls.length > 0
                ? <div className="gdoc-preview-request-content">
                  <span>
                    {Translations(this.state.pageJson.dynamic_accordion_list_glsProducts.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  </span>
                </div> : ''
            }
            {
              this.state.filterData !== undefined && this.state.filterData.productDetails !== undefined && this.state.filterData.productDetails.gls.length > 0
                ? <div className="gdoc-preview-request-gls-products">
                  {
                    this.state.filterData.productDetails.gls.map((item, key) => {
                      if (item.glsProductType.value === 'notionalPool') {
                        return <PreviewNP
                          data={item}
                          countryList={this.state.countryList}
                          accountCountryList={this.state.accountCountryList}
                          newAccounts={this.state.filterData.productDetails.accounts !== undefined ? this.state.filterData.productDetails.accounts : []}
                          echannels={this.state.originalData.productDetails.eChannels !== undefined && this.state.originalData.productDetails.eChannels.length > 0 ? this.state.originalData.productDetails.eChannels : []}
                        />
                      } else if (item.glsProductType.value === 'interest') {
                        return <PreviewIE
                          data={item}
                          countryList={this.state.countryList}
                          accountCountryList={this.state.accountCountryList}
                          echannels={this.state.originalData.productDetails.eChannels !== undefined && this.state.originalData.productDetails.eChannels.length > 0 ? this.state.originalData.productDetails.eChannels : []}
                        />
                      } else if (item.glsProductType.value === 'cashcon') {
                        return <PreviewCashCon
                          data={item}
                          countryList={this.state.countryList}
                          accountCountryList={this.state.accountCountryList}
                          newAccounts={this.state.filterData.productDetails.accounts}
                          echannels={this.state.originalData.productDetails.eChannels !== undefined && this.state.originalData.productDetails.eChannels.length > 0 ? this.state.originalData.productDetails.eChannels : []}
                        />
                      }

                    })
                  }
                </div>
                : ""
            }
            {
              this.state.filterData !== undefined && this.state.filterData.productDetails !== undefined && this.state.filterData.productDetails.ach !== undefined && this.state.filterData.productDetails.ach.length > 0
                ? <div className="gdoc-preview-request-new-achCredit">
                  <AchCredit
                    newAccounts={this.state.filterData.productDetails.accounts}
                    echannels={this.state.originalData.productDetails.eChannels}
                    newAchCredit={this.state.filterData.productDetails.ach}
                    productReferenceObjects={this.state.originalData.productDetails.productReferenceObjects}
                    pageJson={this.state.pageJson}
                    lang={this.props.lang}
                    countryList={this.state.achCountryList}
                    productCountryList={this.state.countryList}
                  />
                </div>
                : ""
            }
            {/*this.state.filterData.productDetails.gls.length > 0 ? <div className="gdoc-preview-request-gls-products"><GlsProducts glsProducts ={this.state.filterData.productDetails.gls} pageJson ={this.state.pageJson} /></div> : "" */}
            {
              this.state.filterData !== undefined && this.state.filterData.productDetails !== undefined && this.state.filterData.productDetails.cff !== undefined && this.state.filterData.productDetails.cff.length > 0
                ? <div className="gdoc-preview-request-new-accounts">
                  <CashFlowForecasting
                    cffProduct={this.state.filterData.productDetails.cff}
                    echannels={this.state.originalData.productDetails.eChannels}
                    pageJson={this.state.pageJson}
                    lang={this.props.lang}
                  />
                </div>
                : ""
            }
            {
              this.state.filterData !== undefined && this.state.filterData.productDetails !== undefined && this.state.filterData.productDetails.eChannels !== undefined && this.state.filterData.productDetails.eChannels.length > 0
                ? <div className="gdoc-preview-request-echannels">
                  <EChannels
                    echannels={this.state.filterData.productDetails.eChannels}
                    newAccounts={this.state.originalData.productDetails.accounts}
                    pageJson={this.state.pageJson}
                    countryList={this.state.countryList}
                    accountCountryList={this.state.accountCountryList}
                    lang={this.props.lang}
                    cffProduct={this.state.filterData.productDetails.cff}
                  />
                </div>
                : ""
            }
            {
              this.state.filterData !== undefined && this.state.filterData.productDetails !== undefined && this.state.filterData.productDetails.corporateCards !== undefined && this.state.filterData.productDetails.corporateCards.length > 0
                ? <div className="gdoc-preview-request-new-corporateCard">
                  <CorporateCard
                    newCorporateCard={this.state.filterData.productDetails.corporateCards}
                    productReferenceObjects={this.state.originalData.productDetails.productReferenceObjects}
                    pageJson={this.state.pageJson}
                    countryList={this.state.countryList}
                    lang={this.props.lang}
                  />
                </div>
                : ""
            }
            {
              this.state.filterData !== undefined && this.state.filterData.productDetails !== undefined && this.state.filterData.productDetails.countryForms.length > 0
                ? <div className="gdoc-preview-additional-data-required">
                  <AdditionalData
                    additionalDataRequired={this.state.filterData.productDetails.countryForms}
                    pageJson={this.state.pageJson}
                    lang={this.props.lang}
                  />
                </div>
                : ""
            }
          </div>
          <div className="gdoc-supportdoc-footer-btn">
            <button
              onClick={() => this.eventToGoCase()}
              className="gdocs-btn-primary case-history-btn"
              name="supportingDoc"
            >
              {Translations(this.state.pageJson.button_addnbutton.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            </button>
          </div>
        </div>);
    } else {
      return (<div>Loading...</div>);
    }
  }
}

PreviewRequest.propTypes = {
  pageJson: PropTypes.object,
  data: PropTypes.object
};

const mapStateToProps = state => {
  let entitiesList = [];
  entitiesList = (Object.keys(state.entities)).map(entityId => {
    const { caseId, entityName } = state.entities[entityId];
    return { entityId, caseId, entityName };
  });
  entitiesList.unshift({
    caseId: 'all',
    entityName: 'All'
  });
  return {
    cases: state.cases,
    entitiesList,
    lang: state.lang,
    customer: state.auth.userDetails
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviewRequest);



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/index.js